import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useApolloClient } from 'react-apollo';
import Select from 'react-select';

import { AccountForAlbumSearch } from '../../../../../graphql/queries/account';
import getLogger from '../../../../../util/logger';
import Label from '../../../../../components/global/Label';

const log = getLogger('AlbumSearchSelect');

const propTypes = {
  albumFolderId: PropTypes.string,
  selectedAlbums: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
  onSelectedAlbumsChange: PropTypes.func,
};

const AlbumSearchSelect = ({
  albumFolderId,
  selectedAlbums,
  onSelectedAlbumsChange,
}) => {
  const client = useApolloClient();
  const [defaultOptions, setDefaultOptions] = useState([]);

  const albumsSearch = async (query = '') => {
    try {
      const {
        data: { me: user },
      } = await client.query({
        query: AccountForAlbumSearch,
        variables: {
          root_album_folder_ids: [albumFolderId],
          album_name: query,
          limit: 999,
        },
      });

      return (user?.albums?.records ?? []).map(album => ({
        label: album.name,
        value: album.id,
      }));
    } catch (error) {
      log.error(error);

      return [];
    }
  };

  // TODO: [albumSearch] Should update in the near-future to a search functionality supported
  // by Tags and the like (according to Toni). Revisit in the near-future.
  // const albumsSearchDebounced = debounce(albumsSearch, 500);

  const getDefaultOptions = async () => {
    const defaultOptionsRes = await albumsSearch();
    setDefaultOptions(defaultOptionsRes);
  };

  useEffect(() => {
    getDefaultOptions();
  }, []);

  return (
    <div className="form-group mb-1">
      <Label id="album-ids" label="Select albums" />
      {/** Using component directly here because wanted to properly test. The wrapper ends up re-rendering the component, breaking tests. */}
      <Select
        inputId="album-ids"
        placeholder="Search by album name"
        className="z-5"
        isMulti
        value={selectedAlbums.map(selectedAlbum => ({
          label: selectedAlbum.name,
          value: selectedAlbum.id,
        }))}
        noOptionsMessage={({ inputValue }) =>
          inputValue
            ? 'No albums found with that criteria...'
            : 'Search by album name...'
        }
        options={defaultOptions ?? []}
        // TODO: [albumSearch] Re-add this once we can search on a more optimal way.
        // loadOptions={albumsSearchDebounced}
        getOptionValue={item => item.value}
        onChange={selectedAlbumsUpdated => {
          if ((selectedAlbumsUpdated?.length ?? 0) === 0) {
            onSelectedAlbumsChange([]);
            return;
          }

          onSelectedAlbumsChange(
            selectedAlbumsUpdated.map(({ label, value }) => ({
              id: value,
              name: label,
            })),
          );
        }}
        cacheOptions={false}
      />
    </div>
  );
};

AlbumSearchSelect.propTypes = propTypes;

export default AlbumSearchSelect;
